import { Redirect } from 'react-router';
import { Background } from '../shared/background/Background';
import { LoadingIndicator } from '../shared/LoadingIndicator';
import { useIsCampaignAdmin } from './useIsCampaignAdmin';

/**
 * Entry point for the help section. Sends users who run campaigns to the campaign guide, and users who only answer
 * questionnaires straight to the FAQs, as the campaign guide isn't relevant to them.
 */
export const HelpHome = () => {
    const isCampaignAdmin = useIsCampaignAdmin();

    if (isCampaignAdmin === undefined) {
        return (
            <Background>
                <LoadingIndicator fullWidth />
            </Background>
        );
    }

    return (
        <Redirect to={isCampaignAdmin ? '/help/campaign-guide' : '/help/faqs'} />
    );
};
